import { render, staticRenderFns } from "./HelpCom.vue?vue&type=template&id=7949c24a&scoped=true&"
import script from "./HelpCom.vue?vue&type=script&lang=js&"
export * from "./HelpCom.vue?vue&type=script&lang=js&"
import style0 from "./HelpCom.vue?vue&type=style&index=0&id=7949c24a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7949c24a",
  null
  
)

export default component.exports